import React, { useState } from 'react';

const ConversionDropsQuickActionModal = ({ record, onClose, onSave, currentUser }) => {
  const [actionType, setActionType] = useState('comment_added');
  const [comment, setComment] = useState('');
  const [newStatus, setNewStatus] = useState(record?.status || 'pendiente');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const actionData = {
        action_type: actionType,
        comment: comment.trim(),
        user_name: currentUser?.name || currentUser?.email || 'Sistema'
      };

      if (actionType === 'status_changed') {
        actionData.old_status = record.status;
        actionData.new_status = newStatus;
        actionData.details = `Estado cambiado de ${record.status} a ${newStatus}`;
      }

      await onSave(record.id, actionData);
    } catch (error) {
      console.error('Error al guardar acción:', error);
      alert(`Error al guardar: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4 rounded-t-xl">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-white">
              ⚡ Acción Rápida - Conversiones Caídas
            </h2>
            <button
              onClick={onClose}
              className="text-white hover:text-red-200 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Record Info */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="font-medium text-gray-900 mb-2">Registro Seleccionado:</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-600">Cliente:</span>
                <span className="ml-2 font-medium">{record?.nombre_cliente}</span>
              </div>
              <div>
                <span className="text-gray-600">Estado Actual:</span>
                <span className={`ml-2 px-2 py-1 rounded-full text-xs font-medium ${
                  record?.status === 'pendiente' ? 'bg-yellow-100 text-yellow-800' :
                  record?.status === 'en_proceso' ? 'bg-blue-100 text-blue-800' :
                  record?.status === 'completado' ? 'bg-green-100 text-green-800' :
                  'bg-red-100 text-red-800'
                }`}>
                  {record?.status === 'pendiente' && '⏳ Pendiente'}
                  {record?.status === 'en_proceso' && '🔄 En Proceso'}
                  {record?.status === 'completado' && '✅ Completado'}
                  {record?.status === 'cancelado' && '❌ Cancelado'}
                </span>
              </div>
              <div className="col-span-2">
                <span className="text-gray-600">Campaña:</span>
                <span className="ml-2">{record?.campana || 'No especificada'}</span>
              </div>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Action Type */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tipo de Acción
              </label>
              <select
                value={actionType}
                onChange={(e) => setActionType(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              >
                <option value="comment_added">💬 Agregar Comentario</option>
                <option value="status_changed">🔄 Cambiar Estado</option>
                <option value="record_updated">📝 Actualización General</option>
              </select>
            </div>

            {/* Status Change */}
            {actionType === 'status_changed' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nuevo Estado
                </label>
                <select
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                >
                  <option value="pendiente">⏳ Pendiente</option>
                  <option value="en_proceso">🔄 En Proceso</option>
                  <option value="completado">✅ Completado</option>
                  <option value="cancelado">❌ Cancelado</option>
                </select>
              </div>
            )}

            {/* Comment */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {actionType === 'status_changed' ? 'Motivo del Cambio' : 'Comentario'}
                {actionType === 'comment_added' && ' *'}
              </label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required={actionType === 'comment_added'}
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                placeholder={
                  actionType === 'status_changed' 
                    ? 'Explica por qué se está cambiando el estado...'
                    : actionType === 'comment_added'
                    ? 'Escribe tu comentario aquí...'
                    : 'Describe la actualización realizada...'
                }
              />
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading || (actionType === 'comment_added' && !comment.trim())}
                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Guardando...
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Ejecutar Acción
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConversionDropsQuickActionModal;
